import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-login-only360',
  templateUrl: './login-only360.component.html',
  })
export class LoginOnly360Component implements OnInit {
  constructor(private dialogRef: MatDialogRef<LoginOnly360Component>,
    private dialog: MatDialog) { }

  ngOnInit() {
  }
  ok() {
    this.dialogRef.close();
  }
}
